import Axios from "axios";
import Cookies from "js-cookie";

const token = Cookies.get("token");
const v1Url = process.env.REACT_APP_V1_API_URL;

const timeoutInMilliSeconds = 100000;

export const $axios = Axios.create({
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
  timeout: timeoutInMilliSeconds,
  baseURL: v1Url,
});

export const $axiosWithToken = Axios.create({
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    Authorization: `Bearer ${token}`,
  },
  timeout: timeoutInMilliSeconds,
  baseURL: v1Url,
});
